import { CharAssetCategory, GameAssets, Module } from "@ak/game-assets"
import { RoguelikeCategory } from "@ak/game-assets/esm/types"

const AssetsClient = GameAssets.create({
    host: __GAME_ASSETS_HOST || undefined,
    prefix: __GAME_ASSETS_PREFIX || undefined,
})

export const getCharPortrait = (charId: string) =>
    AssetsClient.get(Module.CHAR, charId, CharAssetCategory.PORTRAIT)

export const getCharAvatar = (charId: string) =>
    AssetsClient.get(Module.CHAR, charId, CharAssetCategory.AVATAR)

export const getCharIllustration = (charId: string) =>
    AssetsClient.get(Module.CHAR, charId, CharAssetCategory.ILLUSTRATION)

export const getCharSkin = (skinId: string) =>
    AssetsClient.get(Module.CHAR_SKIN, skinId, CharAssetCategory.ILLUSTRATION)

export const getCharSkill = (skillId: string) =>
    AssetsClient.get(Module.CHAR_SKILL, skillId)

export const getRoguelikeItem = (itemId: string) =>
    AssetsClient.get(Module.ROGUELIKE_ITEM, itemId)

export const getRoguelikeBand = (bandId: string) =>
    AssetsClient.get(Module.ROGUELIKE, bandId, RoguelikeCategory.BAND)
